import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      this.authenticationService.menuLoaded.subscribe((data): any => {
        if (data) {
          if (location.pathname !== '/') {
            let menuItems = [];
            let canAccess = false;
            menuItems = [...data];
            menuItems.push({url: '/login'}); // after user login and redirect to the admin layout
            menuItems.push({ url: '/admin/profile' });
            // menuItems.push({url: '/admin/changepassword'});
            menuItems.push({ url: '/admin/floorPlan' });
            menuItems.forEach(item => {
              if (location.href.includes(item.url)) {
                if (item.childs && item.childs.length) {
                  item.childs.forEach((child: any) => {
                    if (location.href.includes(child.url)) {
                      canAccess = true;
                    }
                  });
                } else {
                  canAccess = true;
                }
              }
            });
            if (canAccess) {
              return true;
            } else {
              this.router.navigate(['/admin/notAuthorized']);
            }
          }
        }
      },
        (error: any) => {
          this.router.navigate(['/logout']);
        });
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/logout'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
